import React from 'react';
import './login.css';
 import { Switcher } from "../../components/switcher"
import { Form } from 'react-router-dom';
// import { Outlet } from 'react-router-dom';

export async function action({ request, params } : { request: any, params:any } ) {
    const formData = await request.formData();;
        console.log(request) 
        fetch('/v1/login', {
            method: 'POST',
            body: formData,
          })
    
      }

const FC: React.FC = () => {
	return (
        <div id="sign-in">
            <Form method='post' className="cd-form">
                <p className="fieldset">
                    <label className="image-replace cd-email" htmlFor="signin-email">E-mail</label>
                    <input name="email"  className="full-width has-padding has-border" id="signin-email" type="email" placeholder="E-mail" />
                    <span className="cd-error-message">Error message here!</span>
                </p>

                <p className="fieldset">
                    <label className="image-replace cd-password" htmlFor="signin-password">Password</label>
                    <input name="password" className="full-width has-padding has-border" id="signin-password" type="text" placeholder="Password" />
                    <a href="#0" className="hide-password">Hide</a>
                    <span className="cd-error-message">Error message here!</span>
                </p>

                <p className="fieldset">
                    <input type="checkbox" id="remember-me" />
                    <label htmlFor="remember-me">Remember me</label>
                </p>

                <p className="fieldset">
                    <input className="full-width" type="submit" value="Login" />
                </p>
            </Form>
        </div>
  );
};
export default FC